import { useEffect, useRef, useState } from "react"
import GeneralLayout from "@/layouts/General"
import { useGlobalContext } from "@/global/GlobalContext"
import ContentMAPI from "@/app/api/content-management/content-management"
import { Articles } from "./components/Article"
import { LoadButton } from "@/components/Button"
import { ArticlesRowSkeleton } from "@/components/skeletons/ArticleSkeleton"
const contentMApi = new ContentMAPI()

const Press = () => {
  const { notifyError } = useGlobalContext
  const hideLoadMoreBtn = useRef(true)
  const [onReq, setOnReq] = useState(true)
  const [presses, setPresses] = useState([])
  const [currPresses, setCurrPresses] = useState([])
  const [page, setPage] = useState(1)

  useEffect(() => {
    getPress()
  }, [])

  useEffect(() => {
    if (page > 1) getPress(page)
  }, [page])

  useEffect(() => {
    if (presses.length > currPresses.length) setCurrPresses(presses)
  }, [presses])

  const loadMorePress = () => {
    setPage(page + 1)
  }

  // API request
  const getPress = async (page = 1) => {
    setOnReq(true)
    try {
      let param = { page: page }
      const { data } = await contentMApi.getPresses(param)
      hideLoadMoreBtn.current = data.data.presses.length < 12
      if (presses.length > 0) {
        setPresses(presses.concat(data.data.presses))
      } else {
        setPresses(data.data.presses)
      }
    } catch (err) {
      notifyError(err.message)
    }
    setOnReq(false)
  }

  return (
    <>
      <GeneralLayout bgColor="bg-white" isFixed={false}>
        <section className="px-[25px] sm:px-[50px] md:px-[100px] lg:px-[150px] pb-6 md:pb-8 lg:pb-10">
          <div className="text-center mb-14">
            <span className="uppercase text-2xl sm:text-3xl font-agcasmlt text-[#6d625a] font-light">press</span>
          </div>
          <div className="mb-10 md:mb-12 lg:mb-14">
            <div className="mb-10 md:mb-12 lg:mb-14">
              <span className="uppercase text-sm sm:text-xl font-agcasmlt text-[#6d625a] font-light mb-4 md:mb-6 lg:mb-8">latest</span>
              <div className="font-agcasmlt font-light border-b-[1.5px] border-[#6d625a] mb-8 md:mb-10 lg:mb-12"></div>
            </div>
            {onReq ? (
              presses.length <= 0 ?
                <ArticlesRowSkeleton />
                :
                <Articles presses={currPresses} onReq={onReq} />
            ) : (
              presses.length > 0 ?
                <Articles presses={presses} onReq={onReq} />
                :
                <p className="text-center text-gray-500">No press available.</p>
            )}
            {!hideLoadMoreBtn.current && (
              <div className="pt-8 text-center mt-10">
                <LoadButton onClickBtn={loadMorePress} />
              </div>
            )}
          </div>
          <div className="pt-8">
            <p className="font-agcasmlt font-light text-[12px] md:text-[20px] leading-[16px] sm:leading-[20px] xl:leading-[22px] text-[#6d625a] text-center">If you are interested in feature our restaurant, please do not hesitate to reach out to us.</p>
          </div>
        </section>
      </GeneralLayout>
    </>
  )
}

export default Press